import { useMemo } from 'react';
import { Field, FieldTypes, useResponsive } from '@common-fe/common-fe';

import { VALIDATORS } from '@/common';

export interface FormValues {
  employeeProvidedEmail: string;
}

interface Props {
  email?: string;
  errorText?: string;
}

const useEmailVerificationFields = ({ email, errorText }: Props) => {
  const { isMobile } = useResponsive();
  const fields = useMemo<Field[]>(
    () => [
      {
        name: 'employeeProvidedEmail',
        type: FieldTypes.Email,
        label: 'Employee provided email',
        placeholder: 'Employee provided email',
        showRequireIcon: true,
        defaultValue: email,
        style: isMobile ? undefined : { display: 'grid', gridTemplateColumns: 'minmax(200px, 1fr) 320px' },
        validator: VALIDATORS.EMAIL_REQUIRED,
        manualError: errorText,
      },
    ],
    [email, errorText, isMobile]
  );

  return fields;
};

export default useEmailVerificationFields;
